import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../axios-instance";

export type UserFeedbackCapturedInfo = {
  timeUtc: string;
  userEmail: string;
  module: string;
  browser: string;
  appVersion: string;
};

export type CreateUserFeedbackPayload = {
  feedback: string;
  rating: number;
  allowContact: boolean;
  capturedInfo: UserFeedbackCapturedInfo;
};

export type CreateUserFeedbackResponse = {
  id: string;
};

export const userFeedbackUrls = {
  create: "/user-feedback",
};

export function useCreateUserFeedbackMutation(
  submitFeedback?: (
    payload: CreateUserFeedbackPayload
  ) => Promise<CreateUserFeedbackResponse>
) {
  return useMutation({
    mutationFn:
      submitFeedback ??
      (async (payload: CreateUserFeedbackPayload) => {
        const response = await axiosInstance.post<CreateUserFeedbackResponse>(
          userFeedbackUrls.create,
          payload
        );

        return response.data;
      }),
  });
}
